import React, { useEffect, useState } from "react";
import {
  thermometerStyles,
  thermometerHeight,
  thermometerWidth,
} from "../styles/thermometerStyles";
import clsx from "clsx";
import {
  AveragePrepFqScores,
  PrepFqProfile,
  PrepFqReportProps,
} from "../../../models/users";

interface Props {
  show: boolean;
  animate: boolean;
  height?: number;
  width?: number;
  profile: PrepFqProfile;
  avgScores: AveragePrepFqScores;
  loading: boolean;
}

const Thermometer: React.FC<Props> = ({
  animate,
  show,
  height,
  width,
  profile,
  avgScores,
}) => {
  const classes = thermometerStyles();
  const [progress, setProgress] = useState(0);
  const [rounded, setRounded] = useState(false);
  const [roundedBottom, setRoundedBottom] = useState(false);
  const [averageHeights, setAverageHeights] = useState({ b: 90, a: 50, w: 10 });
  const heightToUse = height ? height : thermometerHeight;
  const widthToUse = width ? width : thermometerWidth;

  useEffect(() => {
    if (show) {
      setTimeout(
        () => {
          const value = (profile?.results?.scaled_score / 100) * heightToUse;
          const b = avgScores?.best_score
            ? (avgScores?.best_score / 100) * heightToUse - 12
            : 90;
          const a = avgScores?.average_score
            ? (avgScores?.average_score / 100) * heightToUse - 12
            : 50;
          const w = (avgScores?.worst_score / 100) * heightToUse - 12;
          if (value > heightToUse - 24) {
            setRounded(true);
          } else if (value < 24) {
            setRoundedBottom(true);
          }
          setAverageHeights({ b, a, w });
          setProgress(value);
        },
        animate ? 250 : 0
      );
    }
  }, [
    profile?.results?.scaled_score,
    avgScores?.best_score,
    avgScores?.average_score,
    avgScores?.worst_score,
    show,
    animate,
    heightToUse,
  ]);
  return (
    <div
      className={classes.root}
      style={{ height: heightToUse, minWidth: widthToUse }}
    >
      <div className={classes.hundredBox}>
        <div className={classes.absoluteCenter}>100</div>
      </div>
      <div
        className={classes.markerContainer}
        style={{ bottom: averageHeights.b ? averageHeights.b : 0 }}
      >
        <div className={clsx(classes.markerLine, classes.markerLineShort)} />
        <div className={classes.marker}>B</div>
      </div>
      <div
        className={classes.markerContainer}
        style={{ bottom: averageHeights.a ? averageHeights.a : 0 }}
      >
        <div className={classes.markerLine} />
        <div className={classes.marker}>A</div>
      </div>
      {/* <div className={classes.markerContainer} style={{ bottom: averageHeights.w }}>
        <div className={clsx(classes.markerLine, classes.markerLineShort)} />
        <div className={classes.marker}>W</div>
      </div> */}
      <div
        className={classes.background}
        style={{ height: heightToUse, width: widthToUse, maxWidth: width }}
      />
      <div
        className={classes.foreground}
        style={{
          height: progress,
          borderTopRightRadius: rounded ? 48 : 0,
          borderTopLeftRadius: rounded ? 48 : 0,
          width: roundedBottom ? widthToUse * (progress / 24) : widthToUse,
          maxWidth: width,
        }}
      />
      <div className={classes.zeroBox}>
        <div className={classes.absoluteCenter}>0</div>
      </div>
    </div>
  );
};

export default Thermometer;
